package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class HomeworkCreateRequest(
    @SerialName("class_section_id") val classSectionId: String,
    @SerialName("subject_id") val subjectId: String,
    val title: String,
    val description: String? = null,
    @SerialName("due_date") val dueDate: String,
    // The OpenAPI contract explicitly defines OPEN as the create default.
    val status: String = "OPEN",
    @SerialName("is_active") val isActive: Boolean = true,
    @SerialName("assigned_by_teacher_id") val assignedByTeacherId: String? = null,
    val id: String? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String> = emptyList()
)

@Serializable
data class HomeworkUpdateRequest(
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("subject_id") val subjectId: String? = null,
    val title: String? = null,
    val description: String? = null,
    @SerialName("due_date") val dueDate: String? = null,
    val status: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    // Null means "leave attachments unchanged"; an empty list explicitly clears them.
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String>? = null
)
